// client/src/coms/serveradmin/AnnouncementAck.js
// Under an announcement message that asks for acknowledgement: "Acknowledge" for members, the count for
// members with Manage announcements.
import React, { useEffect, useState } from 'react';
import { comsApiGet, comsApiPost } from '../comsApi';

export default function AnnouncementAck({ messageId }) {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let alive = true;
    comsApiGet(`/announcements/by-message/${encodeURIComponent(messageId)}`)
      .then((r) => alive && setInfo(r))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [messageId]);
  if (!info || !info.require_ack) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, fontSize: 12 }}>
      {info.acked ? (
        <span style={{ color: 'var(--vx-muted, #b5bac1)' }}>✓ You acknowledged this</span>
      ) : (
        <button
          type="button"
          className="coms-mini-btn primary"
          disabled={busy}
          onClick={async () => {
            setBusy(true);
            try {
              await comsApiPost(`/announcements/by-message/${encodeURIComponent(messageId)}/ack`, {});
              setInfo({ ...info, acked: true, ack_count: info.ack_count != null ? info.ack_count + 1 : undefined });
            } catch {
            } finally {
              setBusy(false);
            }
          }}
        >
          Acknowledge
        </button>
      )}
      {info.ack_count != null ? <span style={{ color: 'var(--vx-muted, #b5bac1)' }}>{info.ack_count} acknowledged</span> : null}
    </div>
  );
}
